import { render } from "./sentItemList.vue?vue&type=template&id=a6f4d652&scoped=true"
import script from "./sentItemList.vue?vue&type=script&lang=js"
export * from "./sentItemList.vue?vue&type=script&lang=js"

import "./sentItemList.vue?vue&type=style&index=0&id=a6f4d652&scoped=true&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6f4d652"]])

export default __exports__